const Time = ({hour, minutes, secounds}) => {

    return ( 
        <span>{String(hour).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:{String(secounds).padStart(2, '0')}</span>
     );
}
 
export default Time;